module.exports = __webpack_public_path__ + "static/img/AIMicroBanner.4b8f521a.png";